import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

const route = 'DRIVERS_IMPORT';

// Initial state
const initialState = {
  openImport: false,
  loading: false,
  importResponse: null,
  error: null,
  fileKey: null,
  delimiter: '',
  importNotification: null,
};

// Async thunk for importing drivers
export const importDrivers = createAsyncThunk(
  `${route}/importDrivers`,
  async (payload, { rejectWithValue }) => {
    try {
      const { fileKey, delimiter } = payload;

      const query = `
            mutation importDrivers ($fileKey: String!, $delimiter: String!) {
                importDrivers (fileKey: $fileKey, delimiter: $delimiter) {
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
      `;

      const response = await clientMutation(
        query,
        {
          fileKey,
            delimiter,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (!response || !response.importDrivers) {
        console.log('Import Drivers response error:', response);
        throw new Error('Error while importing drivers', response.error);
      }

      return response.importDrivers;
    } catch (exc) {
      ExceptionManager(
        exc,
        'modules/driver/views/driverTable/redux/importSlice',
        'importDrivers'
      );
      return rejectWithValue(exc.error);
    }
  }
);

// Slice
const driversImportSlice = createSlice({
  name: route,
  initialState,
  reducers: {
    // Open/close modal actions
    openImportDriversModal: (state, action) => {
      state.openImport = action.payload;
      if (!action.payload) {
        // Reset state when closing modal
        state.importResponse = null;
        state.error = null;
        state.fileKey = null;
        state.importNotification = null;
      }
    },
    
    // Set file key for import
    setFileKeyDriver: (state, action) => {
      state.fileKey = action.payload;
    },
    
    // Set delimiter
    setDelimiterDriver: (state, action) => {
      state.delimiter = action.payload;
    },

    setImportNotificationDriver: (state, action) => {
      // Add validation for notification payload structure
      const notification = action.payload;
      if (notification && typeof notification === 'object') {
        state.importNotification = notification;
      } else {
        state.importNotification = null;
    }
    },
    
    // Reset import state
    resetImportStateDriver: (state) => {
      state.loading = false;
      state.importResponse = null;
      state.error = null;
      state.fileKey = null;
      state.delimiter = '';
      state.importNotification = null;
    },
    
    // Clear error
    clearErrorDriver: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Import drivers pending
      .addCase(importDrivers.pending, (state) => {
      state.loading = true;
        state.error = null;
        state.importResponse = null;
      })
      // Import drivers fulfilled
      .addCase(importDrivers.fulfilled, (state, action) => {
      state.loading = false;
        state.importResponse = action.payload;
        state.error = null;
      })
      // Import drivers rejected
      .addCase(importDrivers.rejected, (state, action) => {
      state.loading = false;
        state.importResponse = null;
        state.error = action.payload || 'Import failed';
    });
  },
});

export const { actions, reducer } = driversImportSlice;

export const { 
  openImportDriversModal, 
  setFileKeyDriver, 
  setDelimiterDriver, 
  resetImportStateDriver, 
  clearErrorDriver, 
  setImportNotificationDriver
} = actions;

export default reducer;